module.exports = __webpack_public_path__ + "img/landing-loading.a0fc523e.jpg";